import React, { Component } from "react";

import { withStyles } from "@material-ui/core/styles";

import cong from "../images/cong.jpg";
//import man from "../images/man.png";
import car from "../images/car.png";
import san from "../images/san.jpg";
import coin from "../images/coin.png";

import pickCoin from "../sounds/pick_coin.ogg";

import { CodeMap, CmdBuf } from "shared/utils";

const styles = theme => ({
  canvasWrap: {
    position: "relative",
    width: "100%"
  },
  canvas: {
    position: "absolute",
    width: "100%"
  },
  hidden: {
    display: "none"
  }
});

const options = {
  size: 12
};
class Map extends Component {
  state = {
    unit: 50,
    degrees: 0,
    mdegrees: 0,
    ndegrees: 0,
    right: 1, //회전방향
    front: 270, //이미지 전진방향(360, 90, 180, 270)
    character: [{ x: 0, y: 0 }], //현재좌표
    moving: [{ x: 0, y: 0 }], //이동수치 에니용
    completed: [{ x: 0, y: 0 }], //이동완료 좌표
    coins: [{ x: 0, y: 0 }], //코인아이템 배열
    total: 0, //총코인수
    pickcoin: 0, //획득코인수
    step: 1,
    speed: 2
  };
  moves = 0;
  buffer = [];
  mapWidth = 0;
  isCancel = false;
  //===========================================================================

  componentDidMount() {
    this.mapWidth = this.wrap.scrollWidth;
    this.handleDrawMap();
    window.addEventListener("resize", () => {
      this.props.changeCodeMirrorHeight(this.wrap.scrollWidth);
    });
    window.turn = CmdBuf.bind(this.turn);
    window.step = CmdBuf.bindD(this.step);
    window.speed = CmdBuf.bind(this.speed);
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (this.props.info !== nextProps.info) return true;
    return false;
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.props.info !== prevProps.info) this.handleDrawMap();
  }
  //===========================================================================

  /**
   * 배경 이미지 그리기.
   */
  handleDrawMap = () => {
    this.props.changeCodeMirrorHeight(this.mapWidth);
    this.setState(
      {
        unit: this.mapWidth / options.size,
        degrees: 0,
        mdegrees: 0,
        ndegrees: 0
      },
      () => {
        this.handleDrawObstacle(this.handleDrawBG());
        this.handleDrawCoin();
        this.handleDrawCharacter();
        this.handleClearCong();
      }
    );
  };

  handleDrawBG = () => {
    return CodeMap.drawBG({
      type: "background",
      canvas: this.canvas_back,
      width: this.mapWidth,
      unit: this.state.unit
    });
  };
  handleDrawObstacle = context => {
    const { info } = this.props;
    if (info.obstacles) {
      CodeMap.draw({
        type: "image",
        image: this.san,
        positions: info.obstacles,
        context,
        unit: this.state.unit
      });
    }
  };
  handleDrawCoin = () => {
    const { info } = this.props;
    if (info.coins) {
      this.setState(
        {
          coins: info.coins,
          total: info.coins.length,
          pickcoin: 0
        },
        () => {
          this.handleDrawCoinOuter();
        }
      );
    }
  };
  handleDrawCoinOuter = () => {
    CodeMap.draw({
      type: "sprite",
      image: this.item,
      positions: this.state.coins,
      canvas: this.canvas_item,
      width: this.mapWidth,
      unit: this.state.unit,
      numberOfFrames: 10,
      ticksPerFrame: 4
    });
  };
  handleDrawCharacter = () => {
    const { info } = this.props;
    if (info.character) {
      this.setState(
        {
          character: info.character
        },
        () => {
          CodeMap.draw({
            type: "image",
            image: this.character,
            positions: info.character,
            canvas: this.canvas_front,
            width: this.mapWidth,
            unit: this.state.unit
          });
        }
      );
    }
  };

  /**
   * 축하 메시지 그리기.
   */
  handleDrawCong = () => {
    const ctx_cong = this.handleSetSize(this.canvas_cong);
    const img = this.cong;
    ctx_cong.drawImage(
      img,
      this.canvas_cong.width * 0.1,
      this.canvas_cong.width * 0.1,
      this.canvas_cong.width * 0.8,
      100
    );
  };
  /**
   * 축하 메시지 지우기.
   */
  handleClearCong = () => {
    const ctx_cong = this.handleSetSize(this.canvas_cong);
    ctx_cong.clearRect(0, 0, this.canvas_cong.width, this.canvas_cong.height);
  };
  /**
   * context 생성.
   */
  handleSetSize = canvas => {
    canvas.width = this.wrap.scrollWidth;
    canvas.height = this.wrap.scrollWidth;
    return canvas.getContext("2d");
  };

  /**
   * 캐릭터 회전 처리.
   */
  handleDrawRotated = (canvas, image) => {
    const { character, moving, degrees, mdegrees, unit } = this.state;
    CodeMap.draw({
      type: "rotate",
      image,
      canvas,
      positions: character,
      moving,
      degrees: degrees + mdegrees,
      unit: unit
    });
  };
  //===========================================================================

  turn = degrees => {
    let right = 1;
    if (!degrees) degrees = 90;
    if (degrees < 0) right = -1;
    this.setState(
      {
        ndegrees: this.state.degrees + degrees,
        mdegrees: 0,
        right,
        moving: [{ x: 0, y: 0 }]
      },
      () => {
        this.moves = 0;
        this.handleAnimateTurn();
      }
    );
  };
  step = count => {
    if (!count) count = 1;
    const { nx, ny } = this.checkStep(count);
    this.setState(
      {
        completed: [{ x: nx, y: ny }]
      },
      () => {
        this.moves = 0;
        this.handleAnimateStep(count);
      }
    );
  };
  speed = speed => {
    if (speed) if (speed > 4 || speed <= 0) speed = 4;
    this.setState(
      {
        speed
      },
      () => {
        CmdBuf.play();
      }
    );
  };
  //===========================================================================

  handlePlay = () => {
    CmdBuf.play();
  };
  checkStep = count => {
    const { character } = this.state;
    const { info } = this.props;
    const { nx, ny } = this.nextPosition(count);
    const max = info.obstacles.length;
    for (let i = 0; i < max; i++)
      if (info.obstacles[i].x === nx && info.obstacles[i].y === ny)
        return { nx: character[0].x, ny: character[0].y };
    return { nx, ny };
  };
  nextPosition = count => {
    const { degrees, front, character } = this.state;
    const real = (degrees + front) % 360;
    let nx = character[0].x;
    let ny = character[0].y;
    switch (real) {
      case 0:
        ny += count > 0 ? -1 : 1;
        break;
      case 90:
        nx += count > 0 ? 1 : -1;
        break;
      case 180:
        ny += count > 0 ? 1 : -1;
        break;
      case 270:
        nx += count > 0 ? -1 : 1;
        break;
      default:
    }
    if (nx < 0) nx = 0;
    if (nx >= options.size) nx = options.size - 1;
    if (ny < 0) ny = 0;
    if (ny >= options.size) ny = options.size - 1;
    return {
      nx,
      ny
    };
  };
  handleDefault = () => {
    if (CmdBuf.isIng()) {
      this.isCancel = true;
      CmdBuf.bindCancel(this.handleCancel);
    } else {
      this.handleCancel();
    }
  };
  handleCancel = () => {
    this.setState(
      {
        unit: 50,
        degrees: 0,
        mdegrees: 0,
        ndegrees: 0,
        right: 1, //회전방향
        front: 270, //이미지 전진방향(0, 90, 180, 270)
        character: [{ x: 0, y: 0 }], //현재좌표
        moving: [{ x: 0, y: 0 }], //이동수치 에니용
        completed: [{ x: 0, y: 0 }], //이동완료 좌표
        coins: [{ x: 0, y: 0 }], //코인아이템 배열
        total: 0, //총코인수
        pickcoin: 0, //획득코인수
        step: 1,
        speed: 2
      },
      () => {
        this.handleDrawMap();
        this.isCancel = false;
      }
    );
  };
  handleAnimateTurn = () => {
    this.setState({ mdegrees: this.moves }, () => {
      this.handleDrawRotated(this.canvas_front, this.character);
      this.moves = this.moves + this.state.speed * this.state.right;
      if (
        (this.state.right > 0 &&
          this.moves + this.state.degrees <= this.state.ndegrees) ||
        (this.state.right < 0 &&
          this.moves + this.state.degrees >= this.state.ndegrees)
      ) {
        requestAnimationFrame(this.handleAnimateTurn);
      } else this.handleResetDegrees();
    });
  };
  handleResetDegrees = () => {
    this.setState(
      {
        degrees: this.state.ndegrees % 360,
        mdegrees: 0
      },
      () => {
        this.handleDrawRotated(this.canvas_front, this.character);
        CmdBuf.play();
      }
    );
  };

  handleAnimateStep = count => {
    const { degrees, front, speed, unit } = this.state;
    const real = (degrees + front) % 360;
    const { canvas_front } = this;
    const ctx_front = canvas_front.getContext("2d");
    const img = this.character;
    let mx = 0;
    let my = 0;
    ctx_front.clearRect(0, 0, canvas_front.width, canvas_front.height); // clear canvas
    switch (real) {
      case 0:
        my = count > 0 ? -this.moves : this.moves;
        break;
      case 90:
        mx = count > 0 ? this.moves : -this.moves;
        break;
      case 180:
        my = count > 0 ? this.moves : -this.moves;
        break;
      case 270:
        mx = count > 0 ? -this.moves : this.moves;
        break;
      default:
    }
    this.setState(
      {
        moving: [{ x: mx, y: my }]
      },
      () => {
        this.handleDrawRotated(canvas_front, img);
        this.moves += speed;
        if (this.moves <= unit) {
          requestAnimationFrame(() => {
            this.handleAnimateStep(count);
          });
        } else this.handleResetStep();
      }
    );
  };
  handleResetStep = () => {
    const { completed, total } = this.state;
    let { coins, pickcoin } = this.state;
    const max = coins.length;
    let coins2 = [];
    let redrawCoins = false;
    for (let i = 0; i < max; i++) {
      if (
        coins[i].x === completed[0].x &&
        coins[i].y === completed[0].y &&
        !coins[i].no
      ) {
        coins2.push(Object.assign({}, coins[i], { no: true }));
        pickcoin += 1;
        redrawCoins = true;
      } else {
        coins2.push(Object.assign({}, coins[i]));
      }
    }
    this.setState(
      {
        character: completed,
        moving: [{ x: 0, y: 0 }],
        coins: coins2,
        total,
        pickcoin
      },
      () => {
        this.handleDrawRotated(this.canvas_front, this.character);
        if (redrawCoins) {
          this._pickCoin.play();
          CodeMap.redrawCoins({
            positions: this.state.coins
          });
        }
        if (total === pickcoin) {
          this.handleDrawCong();
          this.props.handleOpenSuccessForm();
          CmdBuf.end();
        } else {
          CmdBuf.play();
        }
      }
    );
  };

  render() {
    const { classes } = this.props;
    const { canvasWrap, canvas, hidden } = classes;
    return (
      <div ref={ref => (this.wrap = ref)} className={canvasWrap}>
        <canvas ref={ref => (this.canvas_back = ref)} className={canvas} />
        <canvas ref={ref => (this.canvas_item = ref)} className={canvas} />
        <canvas ref={ref => (this.canvas_front = ref)} className={canvas} />
        <canvas ref={ref => (this.canvas_cong = ref)} className={canvas} />
        <img
          ref={ref => (this.cong = ref)}
          src={cong}
          alt="background"
          className={hidden}
        />
        <img
          ref={ref => (this.character = ref)}
          src={car}
          alt="character"
          className={hidden}
        />
        <img
          ref={ref => (this.san = ref)}
          src={san}
          alt="san"
          className={hidden}
        />
        <img
          ref={ref => (this.item = ref)}
          src={coin}
          alt="coin"
          className={hidden}
        />
        <audio ref={ref => (this._pickCoin = ref)} src={pickCoin} />
      </div>
    );
  }
}

export default withStyles(styles)(Map);
